// extracted by mini-css-extract-plugin
export default {"main-view":"lsf-main-view","main-view__annotation":"lsf-main-view__annotation","main-view__infobar":"lsf-main-view__infobar"};
    if(module.hot) {
      // 1637785517364
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  